import { useParams, Navigate } from "react-router-dom";
import SEO from "@/components/SEO";
import { useReveals } from "@/components/Reveal";
import {
  BusinessHero,
  BusinessMetrics,
  BusinessContent,
  BusinessGallery,
  BusinessNavigation,
} from "@/components/business";
import { getBusiness } from "@/data/businesses";

export default function BusinessDetail() {
  const { slug } = useParams();
  const business = getBusiness(slug);
  useReveals([slug]);

  if (!business) return <Navigate to="/businesses" replace />;

  return (
    <main data-testid={`business-detail-${business.slug}`}>
      <SEO
        title={`${business.name} — OA Holding CO LTD.`}
        description={business.tagline}
        path={`/businesses/${business.slug}`}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://oaholding.co/" },
            { "@type": "ListItem", position: 2, name: "Businesses", item: "https://oaholding.co/businesses" },
            { "@type": "ListItem", position: 3, name: business.name, item: `https://oaholding.co/businesses/${business.slug}` },
          ],
        }}
      />
      <BusinessHero business={business} />
      <BusinessMetrics metrics={business.metrics} />
      <BusinessContent business={business} />
      <BusinessGallery business={business} />
      <BusinessNavigation current={business} />
    </main>
  );
}
